import { useState, useEffect } from "react";
import { healthAPI } from "../utils/api";

export default function ServerStatusBanner() {
  const [status, setStatus] = useState("checking"); // checking | waking | ready | offline
  const [elapsed, setElapsed] = useState(0);
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    let timerId = null;
    let pollId = null;
    let startTime = Date.now();

    const checkServer = async () => {
      try {
        const data = await healthAPI.check();
        if (data && data.status === "healthy") {
          setStatus("ready");
          if (timerId) clearInterval(timerId);
          if (pollId) clearInterval(pollId);
          // Hide banner after 3.5s of being ready
          setTimeout(() => setShowBanner(false), 3500);
        }
      } catch {
        setStatus("waking");
      }
    };

    // Initial check
    checkServer();

    // Elapsed timer
    timerId = setInterval(() => {
      setElapsed(Math.floor((Date.now() - startTime) / 1000));
    }, 1000);

    // Poll every 3 seconds until ready
    pollId = setInterval(() => {
      if (status !== "ready") {
        checkServer();
      }
    }, 3000);

    return () => {
      if (timerId) clearInterval(timerId);
      if (pollId) clearInterval(pollId);
    };
  }, []);

  const handleManualRetry = async () => {
    setStatus("checking");
    setElapsed(0);
    try {
      const data = await healthAPI.check();
      if (data && data.status === "healthy") {
        setStatus("ready");
        setTimeout(() => setShowBanner(false), 3500);
      } else {
        setStatus("waking");
      }
    } catch {
      setStatus("waking");
    }
  };

  if (!showBanner && status === "ready") return null;

  return (
    <div className={`server-status-banner status-${status}`}>
      <div className="banner-content">
        {status === "checking" && (
          <>
            <span className="banner-spinner" />
            <span className="banner-text">
              Connecting to NirmanAI Backend...
            </span>
          </>
        )}

        {status === "waking" && (
          <>
            <span className="banner-spinner" />
            <div className="banner-text-group">
              <span className="banner-title">
                ⚡ Render Free Tier Server Wake-Up in Progress ({elapsed}s)
              </span>
              <span className="banner-subtext">
                The Render free tier server goes to sleep mode after 15 mins of inactivity (~20-40s to wake up). Please wait a moment...
              </span>
            </div>
            <button className="banner-retry-btn" onClick={handleManualRetry}>
              🔄 Retry Now
            </button>
          </>
        )}

        {status === "ready" && (
          <>
            <span className="banner-icon">✅</span>
            <span className="banner-text">
              <strong>Server Connected & Ready!</strong> Fast response active.
            </span>
          </>
        )}

        {status === "offline" && (
          <>
            <span className="banner-icon">⚠️</span>
            <span className="banner-text">
              Unable to connect to server. The server might be restarting.
            </span>
            <button className="banner-retry-btn" onClick={handleManualRetry}>
              🔄 Retry
            </button>
          </>
        )}
      </div>
    </div>
  );
}
